import {ErrorMessages} from 'constants/Errors';

import {call} from 'redux-saga/effects';
import {createPost} from 'services/posts';
import {handleError} from 'store/app/error/saga';

import {createPostACS} from '../requestAC';

export function* createPostSaga(action: ReturnType<typeof createPostACS>) {
  try {
    yield call(createPost, action.payload);
  } catch (error) {
    yield call(handleError, error, ErrorMessages.CREATE_POST);
  }
}
